import { makeStyles } from '@material-ui/core'
import React, { useState, useEffect } from 'react'
import { useData } from '../../../data'
import { trackPromise, usePromiseTracker } from 'react-promise-tracker'
import { Button, Form, Input, Select, Checkbox, Upload, Table, Tooltip, Space, Popover } from 'antd'
import { EyeOutlined, EditOutlined, UploadOutlined, MoreOutlined } from '@ant-design/icons'
import PropTypes from 'prop-types'
import { CTAButton } from '../components'
import moment from 'moment'

const { Option } = Select;

const useStyles = makeStyles(theme => ({
    table: {
        width: '100%',
        height: '100%'
    },
    nameCell: {
        minWidth: '25%',
        marginRight: theme.spacing(2)
    },
}))

const ToolForm = ({
    isEdit, tool, onFinish
}) => {
    const classes = useStyles()
    const data = useData()
    const auth = data.auth()
    const [isSuperUser, setIsSuperUser] = useState(false);
    const [form] = Form.useForm();
    const [error, setError] = useState(null)

    const [cookieKeys, setNewCookieKeys] = useState([])


    const tools = data.tools()

    const layout = {
        labelCol: {
            span: 8,
        },
        wrapperCol: {
            span: 11,
        },
    };

    const getcookieKeys = async () => {
        try {
            const allcookieKeys = await tools.getcookiekeys()
            setNewCookieKeys(allcookieKeys)
        } catch (error) {
            console.log(error.message)
        }

    }

    // load the current user
    const loadUser = () => {
        trackPromise(
            auth.getCurrentUser()
                .then((val) => setIsSuperUser(val.is_superuser))
                .catch(console.log), 'get_user'
        )
    }

    // extract file details 
    const normFile = (e) => {
        if (Array.isArray(e)) {
            return e[0];
        }
        return e && e.fileList[0];
    };

    const { promiseInProgress } = usePromiseTracker()



    // get the currently signed in user
    useEffect(() => {
        loadUser()
        getcookieKeys()
        if (isEdit) {
            form.setFieldsValue({
                'name': tool.name,
                'description': tool.description,
                'category': tool.category,
                'type': tool.type,
                'spider_name': tool.spider_name,
                'is_cookies_required': tool.is_cookies_required,
                'cookie_key': tool.cookie_key,
                'sample_input_file': tool.sample_input_file,
                'sample_output_file': tool.sample_output_file
            })
        }
        else
            form.resetFields()
    }, [isSuperUser])



    return (
        <Form {...layout} className="segment-form" form={form} name="nest-messages" onFinish={onFinish}>
            <Form.Item name="name" label="Name" rules={[{ required: true, message: 'Name is required' }]}>
                <Input placeholder="LinkedIn Scraper" />
            </Form.Item>
            <Form.Item name='description' label="Description">
                <Input.TextArea placeholder="LinkedIn scraping" />
            </Form.Item>
            <Form.Item label="Category" name="category" rules={[{ required: true, message: 'Category is required' }]}>
                <Select>
                    <Option value="job">Job</Option>
                    <Option value="contact">Contact</Option>
                    <Option value="email">Email</Option>
                    <Option value="lead_details">Lead details</Option>
                    <Option value="developers">Developers</Option>
                    <Option value="companies">Companies</Option>
                </Select>
            </Form.Item>
            <Form.Item initialValue={false} label="Is cookie required" name="is_cookies_required" valuePropName="checked">
                <Checkbox></Checkbox>
            </Form.Item>

            <Form.Item label="Type" name="type" rules={[{ required: true, message: 'Type is required' }]}>
                <Select>
                    <Option value="scrapy">Scrapy</Option>
                    <Option value="celery">Celery</Option>
                </Select>
            </Form.Item>

            <Form.Item label="Cookie Key" name="cookie_key" rules={[{ required: false, message: 'Cookie key is required' }]}>
                <Select>
                    <Option value="">none</Option>
                    {
                        cookieKeys.map(t => <Option value={t[0]} key={t[1]}>{t[1]}</Option>)
                    }
                </Select>
            </Form.Item>

            <Form.Item label="Spider name" name="spider_name" rules={[{ required: true, message: 'Spider name is required' }]}>
                <Input placeholder="auto_linkedin_scraper" />
            </Form.Item>
            <Form.Item
                label="Sample input file"
                name="sample_input_file"
                getValueFromEvent={normFile}
            >
                <Upload
                    name="sample_input_file"
                    accept=".csv"
                    beforeUpload={() => {
                        return false
                    }}
                    multiple={false}
                >
                    <Button icon={<UploadOutlined />} > Upload input file </Button>
                </Upload>
            </Form.Item>

            <Form.Item
                label="Sample output file"
                name="sample_output_file"
                getValueFromEvent={normFile}
            >
                <Upload
                    name="sample_output_file"
                    accept=".csv"
                    beforeUpload={() => {
                        return false
                    }}
                    multiple={false}
                >
                    <Button icon={<UploadOutlined />} > Upload input file </Button>
                </Upload>
            </Form.Item>
            <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 8 }}>
                <CTAButton type="submit" loading={promiseInProgress}><>Submit</></CTAButton>
            </Form.Item>

            {
                error && (
                    <Form.Item >
                        <p className={classes.error}>{error}</p>
                    </Form.Item>
                )
            }

        </Form>
    )
}

ToolForm.propTypes = {
    /** List of registered tools */
    tool: PropTypes.object,
    /** Is it for new or edit tool */
    isEdit: PropTypes.bool,
    /** function to call while submiting form */
    onFinish: PropTypes.func

}

export default ToolForm
